<template>
	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-bind:style="{ width: screenWidth+'px', height: screenHeight + 'px' }" v-show="pop_show">
		<span class="pop_bg" @click="closeshow()"></span>

		<div id="pop_bodyup" class="pop_content">
			<!-- 动态查询区生成 -->
			<div class="pop_children">
				<div class="pop_head_close">
					<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
				</div>
				<div>
					<h5>{{sheet_no}}&nbsp;&nbsp;维修登记:</h5>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="refresh_data()">
							刷新
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('new')">
							新增
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('add')">
							保存
						</button>&nbsp;
						<button class="pre_btn_ok btn_del" @click="fun_upd('del')">
							删除
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('sub')">
							提交
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('bad')">
							作废
						</button>&nbsp;
					</div>
					<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
						<h3 class="red">
							{{sheet_flag}}
						</h3>
					</div>
				</div>

				<div class="content_edit tab-border">
					<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">

						<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm" :key="index">
							<!-- {{handleImportView(item)}} -->

							<component ref="editfatherzj" :is="NextTickName(item.type)" :inData="checkJson(item)"
								@com-event="refresh_view_edit">
							</component>
						</div>
					</div>

					<div class="content_edit" v-show="file_show">
						<div class="content_edit_item">
							<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;</span>
						</div>
					</div>
				</div>
				<!-- 汽车维修项目明细 -->
				<div class="content_edit tab-border">
					<div>
						<h5>汽车维修项目明细</h5>
					</div>
					<div class="content_btn_row">
						<div class="content_btn">
							<div class="content_btn_item">
								<button class="pre_btn_ok" @click="fun_d1_load()">
									查询
								</button>
								<button class="pre_btn_ok" @click="fun_d1_clear()">
									清空
								</button>
								<button class="pre_btn_ok" @click="fun_d1_update('_add')">
									增加
								</button>
								<button class="pre_btn_ok" @click="fun_d1_update('_upd')">
									修改
								</button>
							</div>
						</div>
					</div>
					<div>
						<div class="content_edit_item tab-row" v-for="(item,index) in d1_parm" :key="index">
							<component :is="NextTickName(item.type)" :inData="checkJson(item)"
								@com-event="refresh_view_d1_edit">
							</component>
						</div>
					</div>
					<!-- 明细部分展示区 -->
					<div id="pre_tab" class="content_edit_item tab-row">
						<table class="pre_tb_detail" border="1" cellpadding="2" cellspacing="1">
							<tr class="tab_header">
								<td v-for="(t,index) in d1_name" :key="index">{{t.name}}</td>
								<td v-show="show_detail_action">操作</td>
							</tr>
							<tr v-for="data_tr in d1_detail" @click="fun_d1_sel(data_tr)">
								<!-- <a href="#"> -->
								<td v-for="(d,index) in data_tr" :key="index"
									v-on:mousemove="show_detaildata($event, d.val, '1')"
									v-on:mouseout="noshow_detaildata">
									<a href="#">{{d.val}}</a>
								</td>
								<!-- </a> -->
								<td v-show="show_detail_action">
									<span @click="fun_d1_update('_del',data_tr)">
										<i class="iconfont icon-shanchu"></i>删除
									</span>
								</td>
							</tr>
						</table>
					</div>
				</div>
				<!-- 汽车维修配件明细 -->
				<div class="content_edit tab-border">
					<div>
						<h5>汽车维修配件明细</h5>
					</div>
					<div class="content_btn_row">
						<div class="content_btn">
							<div class="content_btn_item">
								<button class="pre_btn_ok" @click="fun_d2_load()">
									查询
								</button>
								<button class="pre_btn_ok" @click="fun_d2_clear()">
									清空
								</button>
								<button class="pre_btn_ok" @click="fun_d2_update('_add')">
									增加
								</button>
								<button class="pre_btn_ok" @click="fun_d2_update('_upd')">
									修改
								</button>
							</div>
						</div>
					</div>
					<!-- <div> -->
					<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
						<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in d2_parm"
							:key="index">
							<component :is="NextTickName(item.type)" :inData="checkJson(item)"
								@com-event="refresh_view_d2_edit">
							</component>
						</div>
					</div>
					<!-- </div> -->
					<!-- 明细部分展示区 -->
					<div id="pre_tab" class="content_edit_item tab-row">
						<table class="pre_tb_detail" border="1" cellpadding="2" cellspacing="1">
							<tr class="tab_header">
								<td v-for="(t,index) in d2_name" :key="index">{{t.name}}</td>
								<td v-show="show_detail_action">操作</td>
							</tr>
							<tr v-for="data_tr in d2_detail" @click="fun_d2_sel(data_tr)">
								<!-- <a href="#"> -->
								<td v-for="(d,index) in data_tr" :key="index"
									v-on:mousemove="show_detaildata($event, d.val, '1')"
									v-on:mouseout="noshow_detaildata">
									<a href="#">{{d.val}}</a>
								</td>
								<!-- </a> -->
								<td v-show="show_detail_action">
									<span @click="fun_d2_update('_del',data_tr)">
										<i class="iconfont icon-shanchu"></i>删除
									</span>
								</td>
							</tr>
						</table>
					</div>
				</div>

				<!-- 汽车维修费用合计 -->
				<div class="content_edit tab-border">
					<div>
						<h5>汽车维修费用合计</h5>
					</div>
					<div class="content_btn_row">
						<div class="content_btn">
							<div class="content_btn_item">
								<button class="pre_btn_ok" @click="fun_d_load()">
									查询
								</button>
								<button class="pre_btn_ok" @click="fun_d_clear()">
									清空
								</button>
								<button class="pre_btn_ok" @click="fun_d_update('_add')">
									增加
								</button>
								<button class="pre_btn_ok" @click="fun_d_update('_upd')">
									修改
								</button>
							</div>
						</div>
					</div>
					<div>
						<div class="content_edit_item tab-row" v-for="(item,index) in d_parm" :key="index">
							<component ref="editchildrenzj" :is="NextTickName(item.type)" :inData="checkJson(item)"
								@com-event="refresh_view_d_edit">
							</component>
						</div>
					</div>
					<!-- 明细部分展示区 -->
					<div id="pre_tab" class="content_edit_item tab-row">
						<table class="pre_tb_detail" border="1" cellpadding="2" cellspacing="1">
							<tr class="tab_header">
								<td v-for="(t,index) in d_name" :key="index">{{t.name}}</td>
								<td v-show="show_detail_action">操作</td>
							</tr>
							<tr v-for="data_tr in d_detail" @click="fun_d_sel(data_tr)">
								<!-- <a href="#"> -->
								<td v-for="(d,index) in data_tr" :key="index"
									v-on:mousemove="show_detaildata($event, d.val, '1')"
									v-on:mouseout="noshow_detaildata">
									<a href="#">{{d.val}}</a>
								</td>
								<!-- </a> -->
								<td v-show="show_detail_action">
									<span @click="fun_d_update('_del',data_tr)">
										<i class="iconfont icon-shanchu"></i>删除
									</span>
								</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">

					</div>
				</div>



			</div>
		</div>


	</div>
</template>

<script>
	/* 
	维修弹窗。。。。。。。
	*/
	import api from '@/utils/type.js';
	import {
		Select_PageLength,
		Method_Common,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import {
		JsonStr
	} from '@/utils/method.js';
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		GetRandom
	} from "@/utils/localstore.js";

	export default {
		name: "pre_tan_car_wx",
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				row_id: '',
				sys_date: '',
				sheet_no: '',
				sheet_flag: '',
				screenWidth: '',
				screenHeight: '',
				sel_action: '',
				upd_action: '',

				max_row: [],
				list_m: '',
				parm: [],
				sheet_wx: '',

				// 费用-明细部分参数
				show_detail_content: false,
				show_detail_action: false,
				d_title_name: '',
				d_load_url: '',
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据
				/* 明细 -项目 */
				show_d1: false,
				d1_title_name: '',
				d1_sel_action: '',
				d1_upd_action: '',
				d1_row_id: '',
				d1_sys_date: '',
				d1_parm: [], //明细参数构造
				d1_name: [], //明细标题
				d1_detail: [], //明细数据
				/* 明细 -配件 */
				show_d2: false,
				d2_title_name: '',
				d2_sel_action: '',
				d2_upd_action: '',
				d2_row_id: '',
				d2_sys_date: '',
				d2_parm: [], //明细参数构造
				d2_name: [], //明细标题
				d2_detail: [], //明细数据

				file_show: false,
				file_name: ''



			};
		},
		watch: {
			sheet_flag(val) {
				if (val == '已提交') {
					this.show_detail_action = false;
				} else {
					this.show_detail_action = true;
				}
			}
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			chang_style: function() {
				this.screenWidth = $(window).width();
				this.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
			},
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
				this.chang_style();
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			load_data: async function(res) {
				// console.log('初始参数', res);

				let r = res;
				// 清理缓存
				this.row_id = '';
				this.sel_action = 'exp__car_carRepair';
				this.upd_action = 'car_carRepair';

				this.title = '';
				this.sheet_no = r.sheet_no;
				this.sheet_wx = '';
				// this.sheet_flag=r.flag;
				this.parm = []; //主单保存数据
				this.parm = [{
						"name": "单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "1",
						"r": "1"
					},
					{
						"name": "车牌号码",
						"val": "",
						"key": "c_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "1",
						"r": "1"
					},
					{
						"name": "挂车别名",
						"val": "",
						"key": "cp_no",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_car_bm",
						"sel_name": "",
						"p": "1",
						"x": "1"
					},
					{
						"name": "维修厂",
						"val": "",
						"key": "c_name",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "2",
						"r": "0"
					},
					{
						"name": "维修日期",
						"val": "",
						"key": "c_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"x": "2",
						"r": "0"
					},
					{
						"name": "维修配件",
						"val": "",
						"key": "c_data",
						"type": "text",
						"class": "long3",
						"p": "1",
						"x": "2",
						"r": "0"
					},
					{
						"name": "总金额",
						"val": "",
						"key": "c_amount",
						"type": "label",
						"class": "long1",
						"p": "0",
						"x": "2",
						"r": "0"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"p": "1",
						"x": "3",
						"r": "0"
					},
					{
						"name": "经办人",
						"val": "",
						"key": "u_name",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_alluser",
						"sel_name": "",
						"p": "1",
						"x": "3",
						"r": "0"
					}
				]

				/*初始化 select 数据 start*/


				for (let i = 0; i < this.parm.length; i++) {
					switch (this.parm[i].type) {
						case 'select':
							let t = [];
							let t_sel_action = '';
							t_sel_action = this.parm[i].sel_action;
							if (typeof(t_sel_action) !== 'undefined' && t_sel_action != '') {
								let res = await this.loadClass(t_sel_action);
								if (res.status == '1') {
									t = res.data;
									this.parm[i].list = t;
								}
								// console.log(res);

							}
							break;
						case 'switch':
							let t_in_action = '',
								t_out_action = '';
							t_in_action = this.parm[i].action_in;
							t_out_action = this.parm[i].action_out;
							if (typeof(t_in_action) !== 'undefined' && t_in_action != '') {
								let res_in = await this.loadClass(t_in_action);
								// console.log('收入', res_in);
								if (res_in.status == '1') {
									this.parm[i].list_in = res_in.data;
								} else {
									this.parm[i].list_in = [];
								}
							}

							if (typeof(t_out_action) !== 'undefined' && t_out_action != '') {
								let res_out = await this.loadClass(t_out_action);
								// console.log('支出', res_out)
								if (res_out.status == '1') {
									this.parm[i].list_out = res_out.data;
								} else {
									this.parm[i].list_out = [];
								}
							}

							break;
					}

				}
				this.max_row = [];
				for (let i = 1; i <= this.parm.length; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				// 配置明细
				this.d_parm = [{
						"name": "单号",
						"val": '',
						"key": "sheet_no",
						"type": "none"
					},
					{
						"name": "略",
						"val": '',
						"key": "f_note",
						"type": "none",
						"class": "long1",
						"weight": "0"
					},
					{
						"name": "费用名称",
						"val": "",
						"key": "i_name",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_out_classok_wx",
						"sel_name": ""
					},
					{
						"name": "维修日期",
						"val": "",
						"key": "f_date",
						"type": "none",
						"class": "long1",
						"weight": "0"
					},
					{
						"name": "费用金额",
						"val": "",
						"key": "amount",
						"type": "number"
					}
				];
				this.d_name = [{
						"name": "ID"
					}, {
						"name": "序号"
					}, {
						"name": "单号"
					},

					{
						"name": "费用名称"
					}, {
						"name": "费用金额"
					},
					{
						"name": "有无附件"
					},
					{
						"name": "修改人"
					},
					{
						"name": "修改时间"
					},
					{
						"name": "存储地址"
					},
					{
						"name": "访问地址"
					}
				];
				this.d_detail = [];
				this.d_row_id = '';
				this.d_sys_date = '';
				this.d_sel_action = 'exp_car_carFile';
				this.d_upd_action = 'car_carFile';

				for (let i = 0; i < this.d_parm.length; i++) {
					switch (this.d_parm[i].type) {
						case 'select':
							let t = [];
							let t_sel_action = '';
							t_sel_action = this.d_parm[i].sel_action;
							if (typeof(t_sel_action) !== 'undefined' && t_sel_action != '') {
								let res = await this.loadClass(t_sel_action);
								if (res.status == '1') {
									t = res.data;
									this.d_parm[i].list = t;
								}
								// console.log(res);

							}
							break;
						default:
							break
					}
				}

				//附加明细第一部分
				this.d1_sel_action = 'exp_car_p_name';
				this.d1_upd_action = 'car_p_name';
				this.d1_parm = [{
						"name": "单号",
						"val": '',
						"key": "sheet_no",
						"type": "none"
					},
					{
						"name": "项目名称",
						"val": '',
						"key": "f_name",
						"type": "text",
						"class": "long1",
						"w": "1"
					},
					{
						"name": "工时费用",
						"val": "",
						"key": "f_amount",
						"type": "number",
						"class": "long1",
						"w": "1"
					},
					{
						"name": "施工人员",
						"val": "",
						"key": "f_user",
						"type": "text",
						"class": "long1",
						"w": "0"
					},
					{
						"name": "备注",
						"val": "",
						"key": "f_note",
						"type": "text",
						"class": "long1",
						"w": "0"
					}
				] //明细参数构造
				this.d1_name = [{
						"name": "ID"
					},
					{
						"name": "序号"
					},
					{
						"name": "单号"
					},
					{
						"name": "保养项目"
					},
					{
						"name": "工时费用"
					},
					{
						"name": "施工人员"
					},
					{
						"name": "备注"
					},
					{
						"name": ""
					},
					{
						"name": ""
					}
				] //明细标题
				this.d1_detail = []; //明细数据
				this.d1_row_id = '';
				this.d1_sys_date = '';

				//附加明细第二部分
				this.d2_sel_action = 'exp_car_p_item';
				this.d2_upd_action = 'car_p_item';
				this.d2_parm = [{
						"name": "单号",
						"val": '',
						"key": "sheet_no",
						"type": "none",
						"x": "1"
					},
					{
						"name": "配件名称",
						"val": '',
						"key": "f_name",
						"type": "text",
						"class": "long1",
						"w": "1",
						"x": "1"
					},
					{
						"name": "型号",
						"val": "",
						"key": "f_size",
						"type": "text",
						"class": "long1",
						"w": "0",
						"x": "1"
					},
					{
						"name": "单位",
						"val": "",
						"key": "f_unit",
						"type": "text",
						"class": "long1",
						"w": "0",
						"x": "1"
					},
					{
						"name": "数量",
						"val": "",
						"key": "f_qty",
						"type": "number",
						"class": "long1",
						"w": "1",
						"x": "2"
					},
					{
						"name": "单价",
						"val": "",
						"key": "f_price",
						"type": "number",
						"class": "long1",
						"w": "1",
						"x": "2"
					},
					{
						"name": "实际总金额",
						"val": "",
						"key": "f_amount",
						"type": "number",
						"class": "long1",
						"w": "0",
						"x": "2"
					},
					{
						"name": "备注",
						"val": "",
						"key": "f_note",
						"type": "text",
						"class": "long1",
						"w": "0",
						"x": "2"
					}
				]; //明细参数构造
				this.d2_name = [{
						"name": "ID"
					},
					{
						"name": "序号"
					},
					{
						"name": "单号"
					},
					{
						"name": "配件名称"
					},
					{
						"name": "型号"
					},
					{
						"name": "单位"
					},
					{
						"name": "数量"
					},
					{
						"name": "单价"
					},
					{
						"name": "实际总金额"
					},
					{
						"name": "备注"
					},
					{
						"name": ""
					},
					{
						"name": ""
					}
				]; //明细标题
				this.d2_detail = []; //明细数据
				this.d2_row_id = '';
				this.d2_sys_date = '';

				this.refresh_data();
			},
			refresh_view_edit: async function(d, type) {
				// console.log(d);
				// console.log('编辑更新前', this.parm);

				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {

						if (this.parm[i].type == 'selectnew' || this.parm[i].type == 'select' || this.parm[
								i].type ==
							'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;

							if (String(d.sel_more).indexOf('_to') > 0) {
								let sel_key = String(d.sel_more).substring(0, 1);
								// console.log('编辑联动查询关键字=' + sel_key);

								for (let j = 0; j < this.parm.length; j++) {
									if (this.parm[j].sel_more == sel_key && typeof(this.parm[j]
											.sel_action) !==
										'undefined' && this
										.parm[j].sel_action != '') {

										this.parm[j].list = [];
										this.parm[j].val = '';
										this.parm[j].sel_name = '';

										let res = await this.loadClass(this.parm[j].sel_action, d.val);
										if (res.status == '1') {
											this.parm[j].list = res.data;
										}
										// console.log(this.parm_sel);
										// console.log(this);
										// 强制刷新子组件数据
										this.$refs.editfatherzj[j].refresh_select(JSON.stringify(this.parm[
											j]));
									}
								}
							}

							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}

						break;
					}
				}
				// console.log('编辑更新后', this.parm);

				if (type == 'save') {
					this.fun_upd('add');
				}
			},
			refresh_view_d_edit: async function(d, type) {
				// console.log(d);
				// console.log('编辑更新前', this.parm);

				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == d.key) {

						if (this.d_parm[i].type == 'selectnew' || this.d_parm[i].type == 'select' ||
							this.d_parm[i]
							.type ==
							'radio') {
							this.d_parm[i].val = d.val;
							this.d_parm[i].sel_name = d.sel_name;

							if (String(d.sel_more).indexOf('_to') > 0) {
								let sel_key = String(d.sel_more).substring(0, 1);
								// console.log('编辑联动查询关键字=' + sel_key);

								for (let j = 0; j < this.d_parm.length; j++) {
									if (this.d_parm[j].sel_more == sel_key && typeof(this.d_parm[j]
											.sel_action) !==
										'undefined' && this
										.d_parm[j].sel_action != '') {

										this.d_parm[j].list = [];
										this.d_parm[j].val = '';
										this.d_parm[j].sel_name = '';

										let res = await this.loadClass(this.d_parm[j].sel_action, d
											.val);
										if (res.status == '1') {
											this.d_parm[j].list = res.data;
										}
										// console.log(this.parm_sel);
										// console.log(this);
										// 强制刷新子组件数据
										this.$refs.editchildrenzj[j].refresh_select(JSON.stringify(this
											.d_parm[j]));
									}
								}
							}

							break;
						} else {
							this.d_parm[i].val = d.val;
							break;
						}

						break;
					}
				}
				// console.log('编辑更新后', this.parm);

				if (type == 'save') {
					this.fun_d_update('_add');
				}
			},
			refresh_view_d1_edit: async function(d, type) {
				// console.log(d);
				// console.log('编辑更新前', this.parm);			
				for (let i = 0; i < this.d1_parm.length; i++) {
					if (this.d1_parm[i].key == d.key) {
						this.d1_parm[i].val = d.val;
						break;
					}
				}

				if (type == 'save') {
					this.fun_d1_update('_add');
				}
			},
			refresh_view_d2_edit: async function(d, type) {
				// console.log(d);
				// console.log('编辑更新前', this.parm);			
				for (let i = 0; i < this.d2_parm.length; i++) {
					if (this.d2_parm[i].key == d.key) {
						this.d2_parm[i].val = d.val;
						break;
					}
				}

				if (type == 'save') {
					this.fun_d2_update('_add');
				}
			},

			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			refresh_data: function() {
				this.load_list_m();
				this.fun_d_load();

				this.fun_d1_load();
				this.fun_d2_load();
			},
			load_list_m: function() {
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Select_PageLength(this.sel_action, 1, 100, this
						.sheet_no)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (Number.parseInt(res.data.status) == 1) {
						let item = res.data.data[0];
						// console.log(item);

						for (let d in item) {
							// console.log(d + '=' + item[d]);
							switch (d) {
								case 'id':
									this.row_id = item[d];
									break;
								case 'flag':
									this.sheet_flag = item[d];
									break;
								case 'sys_date':
									this.sys_date = item[d];
									break;
								case 'sheet_no':
									this.sheet_wx = item[d];
									break;
								case 'f_url':
									let tt = JsonStr(item[d]);
									tt = tt.substring(tt.lastIndexOf('/') + 1);
									this.file_name = tt;
									this.file_url = item[d];
									if (this.file_name != '') {
										this.file_show = true;
									} else {
										this.file_show = false;
									}

									break;
								case 'f_src':
									this.file_src = item[d];
									break;
								default:
									break;
							}
						}

						for (let d in item) {
							for (let j = 0; j < this.parm.length; j++) {
								if (this.parm[j].key == d) {
									if (this.parm[j].type == 'select' || this.parm[j]
										.type == 'radio') {
										// console.log(this.parm[j]);
										this.parm[j].val = '';
										this.parm[j].sel_name = item[d];
									} else {
										this.parm[j].val = item[d];
									}

								}
							}
						}
					} else {
						this.$message({
							message: '没有查询到数据!',
							type: 'warning'
						});
					}
				});
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type);

				if (type == 'upd' || type == 'del' || type == 'sub' || type == 'bad') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}

				// 数据格式检查
				// console.log('检查前', this.parm);
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type ==
							'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[
									i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i]
										.sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[
									i].val) > 0) {
								temp = this.parm[i].val;
							} else if (typeof(this.parm[i].list) !== 'undefined' && this
								.parm[i].list.length > 0) {
								temp = '0';
								let tlist = this.parm[i].list;
								for (let j = 0; j < tlist.length; j++) {
									if (tlist[j].val == this.parm[i].sel_name) {
										temp = tlist[j].id;
									}
								}
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								// console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}


				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common(this.upd_action + '_' + type, this.row_id, this
					.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.refresh_data();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			/****明细部分操作 start***********************************************/
			fun_d_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目
				// 文件名称、路径、储存 选择确定
				// this.sheet_flag='';
				// this.sheet_no='';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					}
				}
			},
			fun_d_load: function() {
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				this.d_detail = [];
				this.$post(
					api.http_method, Method_EasySelect('data_' + this.d_sel_action,
						this.sheet_no)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (Number.parseInt(res.data.status) == 1) {
						let t = res.data.data;
						// console.log(t);
						for (let i = 0; i < t.length; i++) {
							let arr = [];
							for (let j in t[i]) {
								// //console.log('key=' + j);       //输出key
								// //console.log('val=' + t[i][j]); //输出key对应的value
								let o = {};
								o.key = j;
								o.val = t[i][j];
								arr.push(o);
							}
							this.d_detail.push(arr);
						}


					} else {
						this.$message({
							message: '没有查询到数据!',
							type: 'warning'
						});
					}
				});
			},
			fun_d_sel: function(item) {
				this.fun_d_clear();
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d_parm.length; j++) {
						if (this.d_parm[j].type == 'select' && this.d_parm[j].key == item[
								i].key) {
							this.$emit('base2-event', this.d_parm[j].slot, item[i].val)
							break;
						} else if (this.d_parm[j].type == 'radio' && this.d_parm[j].key ==
							item[i].key) {
							if (item[i].val == '是') {
								this.radio = '1';
							} else {
								this.radio = '0';
							}
							// //console.log(this.radio);
							this.d_parm[j].val = this.radio;
						} else {
							if (this.d_parm[j].key == item[i].key) {
								this.d_parm[j].val = item[i].val;
								break;
							}
						}
					}
				}
			},
			fun_d_update: async function(type) {
				// console.log('操作类型=' + type);

				if (type == 'upd' || type == 'del') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}



				let d = [];
				d.push(this.sheet_wx)


				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common(this.d_upd_action + '_' + type, this
					.d_row_id, this.d_sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.load_list_d();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);
				// //console.log(item);
				x = that.clientX + 10;
				y = that.clientY;
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" +
					x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// //console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText =
						temp_css;
				}
				if (type == "1" && item != '') {
					temp_css +=
						"max-width: 200px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
					document.getElementById("pre_msg_data").innerText = BackSpecial(
						item);
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// //console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			/****明细----------项目操作 start***********************************************/
			fun_d1_clear: function() {
				this.d1_row_id = '';
				this.d1_sys_date = '';
				for (let i = 0; i < this.d1_parm.length; i++) {
					this.d1_parm[i].val = '';
				}
			},
			fun_d1_sel: function(item) {
				//console.log(item);
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d1_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d1_sys_date = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d1_parm.length; j++) {
						if (this.d1_parm[j].key == item[i].key) {
							this.d1_parm[j].val = item[i].val;
							break;
						}
					}
				}
			},
			fun_d1_load: function() {
				this.d1_detail = [];

				if (this.sheet_no == null || this.sheet_no == '') {
					return;
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Method_EasySelect('data_' + this.d1_sel_action, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (Number.parseInt(res.data.status) == 1) {
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								this.d1_detail.push(arr);
							}
						} else {
							this.$message({
								message: this.d1_title_name + '' + res
									.data.msg,
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});



			},
			fun_d1_update: async function(type, item) {
				if (this.sheet_flag == '已提交') {
					this.$message({
						message: '单号=' + this.sheet_no + ' 已经提交,不能修改明细!',
						type: 'error'
					});
					return;
				}

				let d = [];

				if (type == '_del') {
					for (let j = 0; j < item.length; j++) {
						for (let i = 0; i < this.d1_parm.length; i++) {
							if (item[j].key == this.d1_parm[i].key) {
								switch (item[j].key) {
									case 'id':
										this.d1_row_id = item[j].val;
										break;
									case 'sys_date':
										this.d1_sys_date = item[j].val;
										break;
									default:
										d.push(item[j].val);
										break;
								}
							}
						}
					}

					if (this.d1_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d1_row_id +
								' 请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				} else {
					for (let i = 0; i < this.d1_parm.length; i++) {
						switch (this.d1_parm[i].key) {
							case 'id':
								this.d1_row_id = this.d1_parm[i].val;
								break;
							case 'sys_date':
								this.d1_sys_date = this.d1_parm[i].val;
								break;
							default:
								d.push(this.d1_parm[i].val);
								break;
						}
					}
				}

				if (type == '_upd') {
					if (this.d1_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d1_row_id +
								' 请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				let temp_data = '';
				temp_data = Method_Common('data_' + this.d1_upd_action + type, this
					.d1_row_id, this.d1_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							let that = this;
							setTimeout(function() {
								that.fun_d1_load();
								that.fun_d_load();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})
			},

			/****明细----------项目 end***********************************************/
			/****明细----------配件部分操作 start***********************************************/
			fun_d2_clear: function() {
				this.d2_row_id = '';
				this.d2_sys_date = '';
				for (let i = 0; i < this.d2_parm.length; i++) {
					this.d2_parm[i].val = '';
				}
			},
			fun_d2_sel: function(item) {
				// //console.log(item);
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d2_row_id = item[i].val;
							break;
						case 'id':
							this.d2_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d2_sys_date = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d2_parm.length; j++) {
						if (this.d2_parm[j].key == item[i].key) {
							this.d2_parm[j].val = item[i].val;
							break;
						}
					}
				}
			},
			fun_d2_load: function() {
				this.d2_detail = [];

				this.element_loading = true;
				this.$post(
					api.http_method,
					Method_EasySelect('data_' + this.d2_sel_action, this
						.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (Number.parseInt(res.data.status) == 1) {
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								this.d2_detail.push(arr);
							}
						} else {
							this.$message({
								message: this.d2_title_name + '' +
									res.data.msg,
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});



			},
			fun_d2_update: async function(type, item) {
				if (this.sheet_flag == '已提交') {
					this.$message({
						message: '单号=' + this.sheet_no +
							' 已经提交,不能修改明细!',
						type: 'error'
					});
					return;
				}

				let d = [];
				// console.log(item);
				for (let j = 0; j < item.length; j++) {
					for (let i = 0; i < this.d2_parm.length; i++) {
						if (item[j].key == this.d2_parm[i].key) {
							switch (item[j].key) {
								case 'id':
									this.d2_row_id = item[j].val;
									break;
								case 'sys_date':
									this.d2_sys_date = item[j].val;
									break;
								default:
									d.push(item[j].val);
									break;
							}
						}
					}
				}


				if (type == '_del') {
					await this.fun_d2_sel(item);

					if (this.d2_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d2_row_id +
								' 请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_upd') {
					if (this.d2_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d2_row_id +
								' 请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				// if (type == '_add' || type == '_upd') {
				// 	document.getElementById('isfirst_2').focus();
				// }

				let temp_data = '';
				temp_data = Method_Common('data_' + this.d2_upd_action + type,
					this.d2_row_id, this.d2_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							let that = this;
							setTimeout(function() {
								that.fun_d2_load();
								that.fun_d_load();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})
			},





		}
	};
</script>


<style scoped>
	.tanfile {
		display: -webkit-inline-box;
		max-height: 60vh;
		overflow: auto;
	}

	.pop_content {

		height: auto;
		/* background: #faf5f5; */
		background-color: rgb(195, 219, 250);
		position: fixed;
		border-radius: 3px;
		display: none;
		z-index: 1000;
		padding: 5px;
		/* overflow: hidden; */

		display: inline-block;
		min-width: 720px;
		max-height: 80vh;
		overflow: auto;
	}

	/* .pop_children{
	position: fixed;
	
	z-index: 9999;
} */
	.tab-row {
		display: inline-block;
		overflow: auto;
	}

	.tab-border {

		display: flex;
		flex-direction: column;
		border: 1px solid #aaa;
		border-radius: 5px;
		margin-bottom: 6px;
	}

	/* 表格//////// */
	.pre_tb_detail {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
	需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
	中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;

	}

	.pre_tb_detail td {
		/* padding: 2px 6px 2px 6px; */
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 1px;
		/* width: auto; */
		/* max-width: 256px; */
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;

		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
	word-wrap: break-word;
	word-break: break-all; */
		background-color: #ffffff;
	}


	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
	}

	/* 首列是ID,不排序,隐藏 */
	.pre_tb_detail tr td:nth-child(1) {
		display: none;
	}

	.pre_tb_detail tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	/* 固定隐藏明细部分倒数第2、3列 */
	.pre_tb_detail tr td:nth-last-child(2),
	.pre_tb_detail tr td:nth-last-child(3) {
		display: none;
	}

	.pre_tb_detail td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_tb_detail td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}
</style>